import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ITemplateDialogComponentData, ITemplateDialogExtraButton } from './interfaces';

@Component({
  templateUrl: './template-dialog.component.html',
})
export class TemplateDialogComponent implements OnInit {
    context: unknown = { };
    applyBtnLabel = 'OK';

  constructor(
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITemplateDialogComponentData,
  ) { }

  ngOnInit(): void {
    if (this.data?.templateContext) {
        this.context = this.data.templateContext;
    }
    if (this.data?.applyBtnLabel) {
        this.applyBtnLabel = this.data.applyBtnLabel;
    }
  }

  onApply(): void {
    this.dialogRef.close(this.data.templateContext);
  }

  onClose(): void {
      this.dialogRef.close();
  }

  onExtraBtnClicked(extraBtn: ITemplateDialogExtraButton): void {
      extraBtn.actionSubject.next();
  }

}
